import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { GeographyInfoBus } from '../../models/GeographyInfoBus'
import { GItem } from '../../models/GItem';
import { CommonFunctions } from '../../static/common-functions';
import { GlobalsService } from '../../services/globals.service';
import { CustomerService } from '../../services/customer.service';
import * as _ from 'lodash';
import { MessageType } from '../../enums/MessageType';
import { Message } from '../../models/message';

@Component({
    selector: 'geography-info',
    templateUrl: './geography-info.component.html',
    styleUrls: ['./geography-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GeographyInfoComponent {

    constructor(globals: GlobalsService, private svc_data: CustomerService) {

        this.clear();
    }
    _geographyInfo: GeographyInfoBus = new GeographyInfoBus();
    @Input() set geographyInfo(value: GeographyInfoBus) {
        if (value !== undefined && value !== null) {
            this._geographyInfo = _.cloneDeep(value);
        }
        else {
            this.clear();
        }
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    @Input() showAddressTitle: boolean = true;
    @Input() addressType: string;
    @Input() geoLocs: GItem[];
    @Input() readOnly: boolean;
    @Input() maintainOriginalId: boolean = true;
    @Output() parentMessage: EventEmitter<Message> = new EventEmitter<Message>();
    public getData(): GeographyInfoBus {
        return _.cloneDeep(this._geographyInfo);
    }
    public get hasGeoLocs(): boolean {
      //  return true;
        return CommonFunctions.hasArrayValue(this.geoLocs);
    }
    public get readOnlyInputs(): boolean {
        //  return true;
        return (this.readOnly || this.hasGeoLocs);
    }
    public get hasAddressType(): boolean {
        return CommonFunctions.hasStringValue(this.addressType);
    }
    clear() {
        this._geographyInfo = new GeographyInfoBus();
    }
    geoLocCBOChanged(value: GItem) {
        this.sendParentMessage(MessageType.changed);
        if (CommonFunctions.hasValue(value)) {
            this.svc_data.getGeographyInfo(value.reference).subscribe((data: GeographyInfoBus) => {
                if (this.maintainOriginalId) {
                    let id = this._geographyInfo.geographyId;
                    this._geographyInfo = _.cloneDeep(data);
                    this._geographyInfo.geographyId = id;
                }
                else {
                    this._geographyInfo = _.cloneDeep(data);
                }
            });
        }
        else {
            this.clear();
        }
    }
    dataChange(e: any) {
          this.sendParentMessage(MessageType.changed);
    }
    sendParentMessage(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        let msg: Message = new Message();
        msg.messageType = type;
        msg.messageSubject = subject;
        msg.message = message;
        msg.values = values;
        msg.value = value;
        this.parentMessage.emit(msg);
    }
}
